export default __webpack_public_path__ + "static/media/chevron-right.a7114e77.svg";